import { render, staticRenderFns } from "./TransferCodeConfirm.vue?vue&type=template&id=d41ca2ae"
import script from "./TransferCodeConfirm.vue?vue&type=script&lang=js"
export * from "./TransferCodeConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports